interface FooterProps {
  language: 'pt' | 'en';
}

export default function Footer({ language }: FooterProps) {
  const content = {
    pt: {
      location: 'São Paulo/SP — Brasil',
      tagline: 'Engenharia Patrimonial',
      disclaimer: 'A contemplação não pode ser garantida. Não há promessa de rentabilidade fixa. Custos e condições (taxa de administração e fundos) variam conforme regulamento do grupo e administradora.'
    },
    en: {
      location: 'São Paulo/SP — Brazil',
      tagline: 'Wealth Engineering',
      disclaimer: 'Award cannot be guaranteed. There is no promise of fixed returns. Costs and conditions (administration fee and funds) vary according to group regulations and administrator.'
    }
  };

  const t = content[language];

  return (
    <footer className="bg-white border-t border-black/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10 sm:py-12">

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-9 mb-8 sm:mb-9">

          {/* Logo + identidade integrada */}
          <div className="flex flex-col items-center pt-4 sm:pt-6">
            <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
              <img
                src="https://static.readdy.ai/image/eead7521a07a7e44430d3022e12ebfe4/1ae128347994cfd82758001cb70e14b1.png"
                alt="FGT Capital"
                className="h-10 sm:h-12 w-auto object-contain"
              />
              {/* Separador visual sutil entre logo e jargão */}
              <div className="w-px h-8 sm:h-9 bg-gradient-to-b from-transparent via-[#F97700]/50 to-transparent" />
              <span className="text-[13px] sm:text-[14px] font-bold uppercase tracking-[0.13em] text-[#F97700]">
                {t.tagline}
              </span>
            </div>
            <p className="text-sm text-black/70 text-center sm:ml-5">
              {t.location}
            </p>
          </div>

          {/* Contatos */}
          <div className="space-y-3 sm:pl-5 flex flex-col items-center sm:items-start">
            <div>
              <span className="text-[13px] uppercase tracking-widest text-[#F97700] block mb-2">
                WhatsApp
              </span>
              <a
                href="https://wa.me/5511930322408"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[17px] text-black hover:text-[#F97700] transition-colors cursor-pointer"
              >
                +55 11 93032-2408
              </a>
            </div>
            <div>
              <span className="text-[13px] uppercase tracking-widest text-[#F97700] block mb-2">
                E-mail
              </span>
              <a
                href="mailto:contato@fgt-capital.com"
                className="text-[17px] text-black hover:text-[#F97700] transition-colors cursor-pointer"
              >
                contato@fgt-capital.com
              </a>
            </div>
          </div>
        </div>

        {/* Aviso legal */}
        <div className="pt-8 sm:pt-9 border-t border-black/10">
          <p className="text-[15px] text-black/60 leading-loose max-w-4xl font-bold">
            {t.disclaimer}
          </p>
        </div>

      </div>
    </footer>
  );
}